import { CheckCircleFilled, SyncOutlined } from '@ant-design/icons'
import { Space, Tooltip, theme } from 'antd'
import { FC } from 'react'
import RewindJob from '../../../../../types/api/rewind-job'
import { getPrintProgress } from '../../helpers/get-print-progress'

interface RewindJobNumberCellProps {
    rewindJob?: RewindJob
}

const RewindJobNumberCell: FC<RewindJobNumberCellProps> = ({ rewindJob }) => {
    const { token } = theme.useToken()
    const progress = getPrintProgress(rewindJob?.shipment)

    if (!rewindJob?.id) return <>—</>

    return (
        <Space size={4}>
            {rewindJob.id}
            {progress === 'printing' && (
                <Tooltip title='Печатается'>
                    <SyncOutlined spin style={{ color: token.colorPrimary }} />
                </Tooltip>
            )}
            {progress === 'printed' && (
                <Tooltip title='Напечатано'>
                    <CheckCircleFilled style={{ color: token.green5 }} />
                </Tooltip>
            )}
        </Space>
    )
}

export default RewindJobNumberCell
